import { $post, $get, $getCode } from '@/utils/request'

// 文件服务器地址
export const fileUrl = process.env.NODE_ENV == 'development' ? '' : process.env.VUE_APP_BASE_API // http://192.168.4.23:8059/prod-api

// 发送手机验证码(注册)
export const sendRegPhoneCode = params => $post('/user/sendRegPhoneCode', params)

// 发送手机验证码
export const sendPhoneCode = params => $post('/user/sendPhoneCode', params)

// 校验手机号或者邮箱是否已注册
export const checkPhoneOrEmai = params => $post('/user/checkPhoneOrEmail', params)

// 验证码登录
export const login = params => $post('/login/code', params)

// 登出
export const logout = params => $post('/logout', params)

// 首页
export const homeDetail = params => $get('mainpage', params)

// 招标列表
export const getTender = params => $get('bid/list', params)

// 招标详情
export const getTenderInfo = params => $get(`bid/detail/${params.id}`)

// 新闻列表
export const getNews = params => $get('news/list', params)

// 新闻详情
export const getNewsInfo = params => $get(`news/detail/${params.id}`)

// 项目列表
export const getProject = params => $get('project/list', params)

// 项目详情
export const getProjectInfo = params => $get(`project/detail/${params.id}`)

// 获取轮播图
export const getBannerList = params => $get('/favorite/getLunbotu', params)
